import { MutationTree } from 'vuex';
import UiState from './types/UiState';

const mutations: MutationTree<UiState> = {
  setOverlay(state, action) {
    state.overlay = action === true;
  },

  setLoader(state, action) {
    state.loader = action === true;
  },

  setSidebar(state, action) {
    state.sidebar = action === true;
  },

  setDelay(state, delay) {
    state.delay = delay;
  },
};

export default mutations;
